import { normalizeAdditionalAssetsForForm } from "../../../../pages/Settings/BrandSetup/utils/formDataTransformers";

export const buildDefaultEnabledMap = ({ assets = [] }) => {
  return assets.reduce((map, _, index) => {
    map[index] = true;
    return map;
  }, {});
};

export const getActiveAdditionalAssets = ({ assets = [], enabledMap = {} }) => {
  return assets
    .filter((_, index) => enabledMap[index])
    .map(({ urlImage, prompt, isConditional, variableInfo, variantGroup }) => ({
      urlImage,
      prompt,
      isConditional: !!isConditional,
      variableInfo: !!variableInfo,
      variantGroup: typeof variantGroup === "string" ? variantGroup.trim() : "",
    }));
};

export const buildEnabledMapFromSentAssets = ({
  assets = [],
  sentAssets = [],
}) => {
  const sentUrls = new Set(
    sentAssets.map((asset) => asset?.urlImage).filter(Boolean)
  );

  return assets.reduce((map, asset, index) => {
    map[index] = sentUrls.has(asset.urlImage);
    return map;
  }, {});
};

export const normalizeAdditionalAssets = (rawAssets) => {
  return normalizeAdditionalAssetsForForm(rawAssets);
};
